import { forwardRef, ReactNode } from 'react';
import { NavLink, useMatch } from 'react-router-dom';
import { Button } from './Button';
import { cn } from '@ais-ui/utils';

interface NavLinkButtonProps {
  children: ReactNode;
  to: string;
  id?: string;
  disabled?: boolean;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const NavLinkButton = forwardRef<HTMLButtonElement, NavLinkButtonProps>(
  ({ id, children, to, disabled = false, className, onClick, ...props }, ref) => {
    const match = useMatch(to);
    const variant = match ? 'secondary' : 'ghost';

    return (
      <Button
        id={id}
        asChild={true}
        variant={variant}
        disabled={disabled}
        onClick={onClick}
        {...props}
        ref={ref}
      >
        <NavLink
          to={to}
          className={cn(
            'h-full flex items-center justify-center',
            {
              'opacity-50 pointer-events-none': disabled,
            },
            className
          )}
          {...props}
        >
          {children}
        </NavLink>
      </Button>
    );
  }
);

export { NavLinkButton };
